export default function ExitByGamepadController(view) {
  console.log("listening for gamepad");
  return ({
    index
  }) => {
    console.log("resolve from gamepad");
    view.resolve();
  };
}